import React, { useCallback, useEffect, useMemo } from 'react';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { folderIdIsAllReceiveFolder } from '@web-mail/util';
import { getIn18Text } from 'api';
import { FLOLDER } from '@web-mail/common/constant';
import useShouldUseRealList from '@web-mail/hooks/useShouldUseRealList';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const MailNoticeNum = (props) => {
    const [selectedKeys] = useState2RM('selectedKeys');
    const [mailSearching] = useState2RM('mailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [isNoticeNum, setIsNoticeNum] = useState2RM('noticeNum');
    const shouldUseRealList = useShouldUseRealList();
    const [currentPage, setCurrentPage] = useState2RM('realListCurrentPage', 'doUpdateRealListPage');
    const [, setScrollTop] = useState2RM('scrollTop');
    const filterShowFlag = useMemo(() => {
        if (folderIdIsAllReceiveFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            return true;
        }
        if (selectedKeys.id === FLOLDER.TAG) {
            return false;
        }
        const excludedFolders = [FLOLDER.SENT, FLOLDER.REDFLAG, FLOLDER.TAG, FLOLDER.DRAFT, FLOLDER.DELETED, FLOLDER.SPAM];
        return selectedKeys && !excludedFolders.includes(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id);
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    const handleNewMailBarClick = useCallback(() => {
        setIsNoticeNum(0);
        if (!shouldUseRealList || (shouldUseRealList && currentPage === 1)) {
            setScrollTop(0);
        }
        if (shouldUseRealList && currentPage > 1) {
            setCurrentPage({ page: 1 });
        }
    }, []);
    useEffect(() => {
        setIsNoticeNum(0);
    }, [(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) + ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '')]);
    useMsgRenderCallback('mailChanged', (ev) => {
        const { eventStrData } = ev;
        if (eventStrData == 'mailMergeModelChange') {
            setIsNoticeNum(0);
        }
    });
    return filterShowFlag && !isSearching && isNoticeNum > 0 ? (React.createElement("div", { className: "m-list-num", onClick: handleNewMailBarClick }, getIn18Text('FENGXINYOUJIAN', { count: isNoticeNum }))) : (React.createElement(React.Fragment, null));
};
export default MailNoticeNum;
